export default "__VITE_ASSET__c3ee228a__"